import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2'
import { toast } from 'react-toastify';

export const useActions = ({
    //------------- Generales
    marvarApi, dispatch, user, onLogout, location, paramsURL, toggle,
    //------------- globalStates
    globalStates,
    //------------- defalutData
    defaultData, 
    //------------- Helpers
    Helpers,
    //------------- Forms
    Forms,
    //------------- FetchData
    FetchData
}) =>{

    // Para redirigir a otras pantallas
    const navigate = useNavigate();

    // ------------------------------------ DEMO MODAL
    const abrirModal = (_, title, compont, dataRequest) => {
        toggle(_, title, compont, dataRequest)
    }
    
    const cerrarModal = () => {
        toggle()
    }

    const handleClickDemoModal = async (_, title, compont, dataRequest) => {
        abrirModal(_, title, compont, dataRequest)
    }

    // ------------------------------------ DEMO MODAL

    const handleClickShowTransactionForm = (flag, flagModalOpeningMode) => {

        // console.log({flag, flagModalOpeningMode})
        
        const { setShowTransactionsForm, setModalOpeningMode } = globalStates

        setShowTransactionsForm(flag)
        setModalOpeningMode(flagModalOpeningMode)

    }

    // Cancela la visualizacion del formulario al darle click al botón "Cancelar"
    const handleClickHideTransactionForm = () => {

        const { FormTransaction } = Forms
        const { onResetForm } = FormTransaction

        onResetForm()
        handleClickShowTransactionForm(false)

    }

    const handleClickFetchAllTransactions = async (idpago) => {

        const { FormFilter } = Forms
        const { fetchTransactionsByPayment, fetchPaymentsByContract } = FetchData

        // Fetch para listar todos los movimientos
        fetchTransactionsByPayment.setParamsToSearch({
            idpago: idpago
        })
        fetchTransactionsByPayment.executeFetch()

        // Fetch para lsitar todos los pagos y actualizar info
        fetchPaymentsByContract.setParamsToSearch({
            contrato_codigo: FormFilter.formState.arriendo_registro
        })
        fetchPaymentsByContract.executeFetch()

    }

    const handleClickOpenTransactionsModal = async (_, title, compont, dataRequest, flagModalOpeningMode) => {

        const { fetchTransactionsByPayment } = FetchData
        const { setModalOpeningMode } = globalStates

        // console.log('[useActions][handleClickOpenTransactionsModal] dataRequest: ', dataRequest)
        // console.log('[useActions][handleClickOpenTransactionsModal] dataRequest.data: ', dataRequest.data)

        fetchTransactionsByPayment.setParamsToSearch({
            idpago: dataRequest.data.idpago
        })
        fetchTransactionsByPayment.executeFetch()

        
        setModalOpeningMode(flagModalOpeningMode)
        abrirModal(_, title, compont, dataRequest)
    }

    const handleClickEnableTransaction = async (idmovimiento, idpago) => {
        Swal.fire({
            title: '¿Está seguro de Activar este registro?',
            text: 'Esta acción hará que el registro vuelva a mostrarse en los listados de movimientos que se encuentran en todo el sistema y podrá asociar información a él nuevamente',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Continuar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/leases/management-payments/enable-movimiento/${idmovimiento}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllTransactions(idpago)

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickDisableTransaction = async (idmovimiento, idpago) => {
        Swal.fire({
            title: '¿Está seguro de Desactivar este registro?',
            text: 'Esta acción hará que el registro sea removido de los listados de movimientos que se encuentran en todo el sistema y no podrá asociar información a él',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Continuar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.put(`/leases/management-payments/disable-movimiento/${idmovimiento}`)
                .then(({ data }) => {
                    
                    alertMessage(data)
                    handleClickFetchAllTransactions(idpago)

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
    }

    const handleClickDeleteTransaction = async (idmovimiento, idpago) => {

        Swal.fire({
            title: '¿Está seguro de eliminar este registro?',
            text: 'Esta acción no se puede deshacer, haga click en "Eliminar" para continuar',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ff6219',
            cancelButtonText: 'Cancelar',
            confirmButtonText: 'Eliminar',
        }).then(async result => {
            if (result.isConfirmed) {
                await marvarApi.delete(`/leases/management-payments/delete-movimiento/${idmovimiento}`)
                .then(({ data }) => {
                    
                    console.log(data)
                    // alertMessage(data)
                    handleClickFetchAllTransactions(idpago)

                })
                .catch(error => {
                    console.log('API ERROR: ', error)
                })
            }
        })
        
    }

    const handleChangeTypeTransaction = async (e) => {

        const { FormTransaction } = Forms
        const { setFormState, } = FormTransaction

        const { name, value } = e.target


        setFormState(prevState => ({
            ...prevState,
            // efectivo
            idcaja: '',
            deposito_observaciones: '',
            // deposito
            boleta_numero: '',
            idbanco: '',
            aprobacion_referencia_ach: '',
            aprobacion_check: '',
            aprobacion_observaciones: '',
            acceptedFiles: [],
            fileRejections: [],
            [ name ]: value
        }))
    }

    const handleClickShowTransactionInfo = async (itemData, flagShowTransactionForm, flagModalOpeningMode) => {
        
        // console.log('[useAction][handleClickShowTransactionInfo] itemData: ', itemData)

        const { fetchSpecificTransaction } = FetchData 
        const { setModalOpeningMode } = globalStates
        const { FormTransaction } = Forms
        const { setFormState} = FormTransaction

        fetchSpecificTransaction.setParamsToSearch({
            idmovimiento: itemData.idmovimiento,
            fecthTransactionInfo: {
                flag: true,
                refSetFormState: setFormState
            }
        })
        fetchSpecificTransaction.executeFetch()

        handleClickShowTransactionForm(flagShowTransactionForm)
        setModalOpeningMode(flagModalOpeningMode)
    }

    const handleClickDownloadImage = async ( customFileName, openUrl) => {
        
        // const enlaceTemporal = document.createElement('a');
        // enlaceTemporal.href = openUrl;
        // enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
        // document.body.appendChild(enlaceTemporal);
        // enlaceTemporal.click();
        // document.body.removeChild(enlaceTemporal);

        try {
            const response = await fetch(openUrl);
            const blob = await response.blob();
      
            // Crear un enlace temporal
            const enlaceTemporal = document.createElement('a');
            enlaceTemporal.href = window.URL.createObjectURL(blob);
            enlaceTemporal.download = customFileName; // Puedes cambiar el nombre del archivo
            document.body.appendChild(enlaceTemporal);
      
            // Simular clic en el enlace para iniciar la descarga
            enlaceTemporal.click();
      
            // Eliminar el enlace temporal
            document.body.removeChild(enlaceTemporal);
            
            toast.success('Se ha descargado la imagen');

          } catch (error) {
            console.error('Error al descargar la imagen', error);
          }

    }

    const _calculateTotalQuetzalsAndDollars = async ({refSetFormState, movimiento_monto, movimiento_moneda, movimiento_tipo_cambio}) => {
        switch(movimiento_moneda){
            case 'QUETZAL':
                refSetFormState(prevState => ({
                    ...prevState,
                    movimiento_quetzales: parseFloat(movimiento_monto).toFixed(2) || '', // Valor predeterminado si es indefinido
                    movimiento_dolares: parseFloat(movimiento_monto / movimiento_tipo_cambio).toFixed(2) || '', // Valor predeterminado si es indefinido
                }))
            break
            case 'DOLAR':
                refSetFormState(prevState => ({
                    ...prevState,
                    movimiento_quetzales: parseFloat(movimiento_monto * movimiento_tipo_cambio).toFixed(2) || '', // Valor predeterminado si es indefinido
                    movimiento_dolares: parseFloat(movimiento_monto).toFixed(2) || '', // Valor predeterminado si es indefinido
                }))
            break
            default:
                console.log(`No se reconoce la selección: ${movimiento_moneda}`)
            break
        }
    }

    const handleChangeAmount = (event) => {
        const { FormTransaction } = Forms
        const { formState, setFormState } = FormTransaction

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.movimiento_moneda !== '' && formState.movimiento_tipo_cambio !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: value,
                movimiento_moneda: formState.movimiento_moneda,
                movimiento_tipo_cambio: formState.movimiento_tipo_cambio
            })
        }

    }

    const handleChangeTypeCurrency = (event) => {
        const { FormTransaction } = Forms
        const { formState, setFormState } = FormTransaction

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.movimiento_monto !== '' && formState.movimiento_tipo_cambio !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: formState.movimiento_monto,
                movimiento_moneda: value,
                movimiento_tipo_cambio: formState.movimiento_tipo_cambio
            })
        }

    }

    const handleChangeExchangeRate = (event) => {
        const { FormTransaction } = Forms
        const { formState, setFormState } = FormTransaction

        const { name, value } = event.target
        setFormState(prevState => ({
            ...prevState,
            [name ]: value
        }))

        if(formState.movimiento_monto !== '' && formState.movimiento_moneda !== '') {
            _calculateTotalQuetzalsAndDollars({
                refSetFormState: setFormState,
                movimiento_monto: formState.movimiento_monto,
                movimiento_moneda: formState.movimiento_moneda,
                movimiento_tipo_cambio: value
            })
        }

    }

    const handleClickPrintPaymentTicket = async (idmovimiento) => {

        const { fetchSpecificTransaction } = FetchData
        
        fetchSpecificTransaction.setParamsToSearch({
            idmovimiento: idmovimiento,
            printTicketFlag: true
        })
        fetchSpecificTransaction.executeFetch()

    }

    const onSubmitFormFilter = async () => {

        const { FormFilter } = Forms
        const { formState } = FormFilter

        const { fetchPaymentsByContract, fetchInfoLease } = FetchData

        if(formState.arriendo_registro === '') {
            toast.warn("No ha indicado el identificador a buscar", {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
            return
        }

        fetchPaymentsByContract.setParamsToSearch({contrato_codigo: formState.arriendo_registro})
        fetchPaymentsByContract.executeFetch()
        
        fetchInfoLease.setParamsToSearch({contrato_codigo: formState.arriendo_registro})
        fetchInfoLease.executeFetch()

    }

    const onSubmitTransactionForm = async (e, idpago) => {

        e.preventDefault()

        const { fetchSpecificTransaction } = FetchData
        const { FormTransaction } = Forms
        const { formState, onResetForm } = FormTransaction

        // Determina si se hace un pago en "efectivo" para confirmar que se incluya información de la caja que recibirá el dinero
        if(formState.movimiento_tipo === 'EFECTIVO' && formState.idcaja === ''){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará pago en "efectivo" pero no ha especificado la "caja" que recibe el dinero'
            })
            return;
        }

        // Determina si se hace un "deposito" para confirmar que se incluya información de la boleta
        if(formState.movimiento_tipo === 'DEPOSITO' && formState.boleta_numero ===''){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará un "deposito" pero no ha especificado el "número de boleta"'
            })
            return;
        }

        // Determina si se hace un "deposito" para confirmar que se incluya información de la boleta
        if(formState.movimiento_tipo === 'DEPOSITO' && formState.idbanco ===''){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará un "deposito" pero no ha especificado el "banco"'
            })
            return;
        }

        // Determina si se hace un "deposito" para confirmar que se incluya información de la boleta
        if(formState.movimiento_tipo === 'DEPOSITO' && formState.acceptedFiles.length<=0){
            Swal.fire({
                icon: 'error',
                title: 'Información incompleta',
                text: 'Se ha indicado que se registrará un "deposito" pero no ha especificado una "foto", o no ha seleccionado una foto valida'
            })
            return;
        }

        const _data = new FormData();
        _data.append('idpago', idpago);
        _data.append('idcaja', formState.idcaja);
        _data.append('idbanco', formState.idbanco);
        _data.append('movimiento_usuario', user.username);
        _data.append('movimiento_fecha', formState.movimiento_fecha);
        _data.append('movimiento_tipo', formState.movimiento_tipo);
        _data.append('movimiento_monto', formState.movimiento_monto);
        _data.append('movimiento_moneda', formState.movimiento_moneda);
        _data.append('movimiento_tipo_cambio', formState.movimiento_tipo_cambio);
        _data.append('movimiento_quetzales', formState.movimiento_quetzales);
        _data.append('movimiento_dolares', formState.movimiento_dolares);
        _data.append('movimiento_observaciones', formState.movimiento_observaciones);
        _data.append('boleta_numero', formState.boleta_numero);
        _data.append('usuario_creo', user.username);
        _data.append('fecha_creo', new Date() );

        formState.acceptedFiles.forEach((file, index) => {
            _data.append(`images`, file);
        });

        await marvarApi.post( `/leases/management-payments/registrar-movimiento`, _data )
            .then(({ data }) => {

                console.log('onSubmitTransactionForm ---- ', data)

                toast.success(data.message, {
                    position: "top-right",
                    theme: "colored",
                    autoClose: false,
                })
                
                
                fetchSpecificTransaction.setParamsToSearch({
                    idmovimiento: data.rows[0].insertId,
                    printTicketFlag: true
                })
                fetchSpecificTransaction.executeFetch()
                
                onResetForm()
                handleClickFetchAllTransactions(idpago)
                handleClickHideTransactionForm()

            })
            .catch(error => {
                console.log('API ERROR: ', error)

                toast.warn(`Hubo un problema interno, detalles técnicos: ${error}`, {
                    position: "top-right",
                    theme: "colored",
                    autoClose: false,
                })

                onResetForm()
                handleClickFetchAllTransactions(idpago)
                handleClickHideTransactionForm()
            })

    }

    

    // ----------------------------------------------------------------------------------------------

    return Object.freeze({
        abrirModal,
        cerrarModal,
        handleClickDemoModal,
        handleClickShowTransactionForm,
        handleClickHideTransactionForm,
        handleClickOpenTransactionsModal,
        handleClickEnableTransaction,
        handleClickDisableTransaction,
        handleClickDeleteTransaction,
        handleClickFetchAllTransactions,
        handleChangeTypeTransaction,
        handleClickShowTransactionInfo,
        handleClickDownloadImage,
        handleChangeAmount,
        handleChangeTypeCurrency,
        handleChangeExchangeRate,
        handleClickPrintPaymentTicket,
        onSubmitFormFilter,
        onSubmitTransactionForm,
    })
}

/**
 * Funcion para gestionar las alertas de toastify
 * @param {*} res : respuesta del API / custom (debe ser un json "{}")
 * @param {*} toggle : toggle de modal
 */
const alertMessage = (res, toggle) => {

    if (res) {
        const { flag, message } = res
        if (flag === 'OK') {
            toast.success(message, {
                position: "top-right",
                theme: "colored"
            })
            toggle && toggle()
        } else {
            toast.warn(message, {
                position: "top-right",
                theme: "colored",
                autoClose: false,
            })
        }
    } else {
        toast.warn('Error interno, notifique a Soporte técnico!.', {
            position: "top-right",
            theme: "colored",
            autoClose: false,
        })
    }
}